import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

const compute = (items) => ({
  items,
  total: items.reduce((s, i) => s + i.product.sale_price * i.quantity, 0),
  item_count: items.reduce((s, i) => s + i.quantity, 0),
});

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState({ items: [], total: 0, item_count: 0 });
  const [isOpen, setIsOpen] = useState(false);

  const addToCart = (product, quantity = 1, size = 'M', color = 'Default') => {
    setCart(prev => {
      const existing = prev.items.find(i => i.product_id === product.id);
      const items = existing
        ? prev.items.map(i => i.product_id === product.id ? { ...i, quantity: i.quantity + quantity } : i)
        : [...prev.items, { product_id: product.id, product, quantity, size, color }];
      return compute(items);
    });
    setIsOpen(true);
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity <= 0) { removeItem(productId); return; }
    setCart(prev => compute(prev.items.map(i => i.product_id === productId ? { ...i, quantity } : i)));
  };

  const removeItem = (productId) => {
    setCart(prev => compute(prev.items.filter(i => i.product_id !== productId)));
  };

  const clearCart = () => setCart({ items: [], total: 0, item_count: 0 });
  const fetchCart = () => {}; // no-op for API compatibility

  return (
    <CartContext.Provider value={{ cart, loading: false, isOpen, setIsOpen, addToCart, updateQuantity, removeItem, clearCart, fetchCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within CartProvider');
  return ctx;
};
